import React from 'react';
import "./styles/TextEditor.scss"
import {LexicalComposer} from "@lexical/react/LexicalComposer";
import { HeadingNode } from "@lexical/rich-text"
import {RichTextPlugin} from "@lexical/react/LexicalRichTextPlugin";
import {ContentEditable} from "@lexical/react/LexicalContentEditable";
import {LexicalErrorBoundary} from "@lexical/react/LexicalErrorBoundary";
import {isRTL} from "../../../services/i18n";
import ToolbarPlugin from "./plugins/ToolbarPlugin";
import {editorTheme} from "./helper";
import {HistoryPlugin} from "@lexical/react/LexicalHistoryPlugin";
import "./styles/TextFormatStyling.scss"
import { ListNode, ListItemNode } from '@lexical/list';
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import CustomOnChangePlugin from "./plugins/CustomOnChangePlugin";
import {HighlightNode} from "./nodes/HighlightNode";

const TextEditor = (props) => {
    const { placeholder, onChange, value } = props;

    const initialConfig = {
        namespace: 'rich-text-editor',
        theme: editorTheme,
        onError: () => {},
        nodes: [HeadingNode, ListNode, ListItemNode, HighlightNode]
    }

    return (
        <div id={'lexical-text-editor'}>
            <LexicalComposer initialConfig={initialConfig}>
                <ToolbarPlugin/>
                <div style={{position: 'relative', height: 'calc(100% - 52px)'}}>
                    <RichTextPlugin contentEditable={<ContentEditable id={'lexical-rich-text-content'}/>}
                                    ErrorBoundary={LexicalErrorBoundary}
                                    placeholder={<div className={`editor-placeholder ${isRTL() && 'position-rtl'}`}>{placeholder}</div>}
                    />
                </div>
                <ListPlugin/>
                <AutoFocusPlugin/>
                <HistoryPlugin/>
                <CustomOnChangePlugin onChange={onChange} value={value}/>
            </LexicalComposer>
        </div>
    );
};

export default TextEditor;